import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FiCreditCard } from "react-icons/fi";
import { asignPlantoVendor, ActivePlanList } from "../../redux/services/SubscriptionServices/Subscription.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { ActiveUserList } from "../../redux/services/User Services/User.Services";

function AsignToVendorPlan() {
  const navigate = useNavigate();

  const [vendors, setVendors] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    vendor_id: "",
    plan_id: "",
    start_date: new Date().toISOString().slice(0, 10),
    payment_amount: "",
    payment_method: "cash",
    payment_id: "",
    notes: "",
    status: 1,
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handlePlanChange = (value) => {
    const plan = planList.find((p) => String(p.id) === String(value));
    setFormData((prev) => ({
      ...prev,
      plan_id: value,
      payment_amount: plan?.price ?? prev.payment_amount,
    }));
    if (errors.plan_id) setErrors((prev) => ({ ...prev, plan_id: "" }));
  };

  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const res = await ActiveUserList();
        setVendors(res?.data || []);
      } catch (error) {
        console.log("Staff API error:", error);
      }
    };
    fetchVendor();
  }, []);

  useEffect(() => {
    const fetchActivePlan = async () => {
      try {
        const res = await ActivePlanList();
        setPlanList(res?.data || []);
      } catch (error) {
        console.log("Staff API error:", error);
      }
    };
    fetchActivePlan();
  }, []);
// ---- Selected plan for preview ----
const selectedPlan = planList.find(
  (p) => String(p.id) === String(formData.plan_id)
);
  const validate = () => {
    const err = {};
    if (!formData.vendor_id) err.vendor_id = "Vendor is required";
    if (!formData.plan_id) err.plan_id = "Plan is required";
    if (!formData.start_date) err.start_date = "Start date is required";
    if (formData.payment_amount === "" || isNaN(Number(formData.payment_amount)))
      err.payment_amount = "Valid payment amount is required";
    if (!formData.payment_method) err.payment_method = "Payment method is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = {
        vendor_id: formData.vendor_id,
        plan_id: Number(formData.plan_id),
        start_date: formData.start_date,
        payment_amount: Number(formData.payment_amount),
        payment_method: formData.payment_method,
        payment_id: formData.payment_id?.trim() || null,
        notes: formData.notes?.trim() || null,
      };

      const res = await asignPlantoVendor(payload);

      if (res?.success !== false) {
        successToast(res?.message || "Plan created successfully");
        navigate("/plan-vender-list");
      } else {
        errorToast(res?.message || "Failed to create plan");
      }
    } catch (error) {
      console.error("Add plan error:", error);
      errorToast(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create plan"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Assign Plan to Vendor</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/subscription-list">Subscriptions</Link>
            <span className="mx-2">/</span>
            <span>Add</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card mt-2">
          <div className="card-body">
            <form onSubmit={handleSubmit} className="row g-3" noValidate>

              {/* Vendor */}
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">
                  Select Vendor <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.vendor_id ? "is-invalid" : ""}`}
                  value={formData.vendor_id}
                  onChange={(e) => handleChange("vendor_id", e.target.value)}
                >
                  <option value="">Select Vendor</option>
                  {vendors.map((vendor) => (
                    <option key={vendor.user_id} value={vendor.user_id}>
                      {vendor.name || vendor.mobile || vendor.user_id}
                    </option>
                  ))}
                </select>
                {errors.vendor_id && (
                  <div className="text-danger small mt-1">{errors.vendor_id}</div>
                )}
              </div>

              {/* Plan */}
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">
                  Select Plan <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.plan_id ? "is-invalid" : ""}`}
                  value={formData.plan_id}
                  onChange={(e) => handlePlanChange(e.target.value)}
                >
                  <option value="">Select Plan</option>
                  {planList.map((plan) => (
                    <option key={plan.id} value={plan.id}>
                      {plan.name}
                    </option>
                  ))}
                </select>
                {errors.plan_id && (
                  <div className="text-danger small mt-1">{errors.plan_id}</div>
                )}
              </div>

              {/* Start Date */}
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Start Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className={`form-control ${errors.start_date ? "is-invalid" : ""}`}
                  value={formData.start_date}
                  onChange={(e) => handleChange("start_date", e.target.value)}
                />
                {errors.start_date && (
                  <div className="text-danger small mt-1">{errors.start_date}</div>
                )}
              </div>

              {/* Payment Amount */}
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Payment Amount (₹) <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FiCreditCard size={14} />
                  </span>
                  <input
                    type="number"
                    step="0.01"
                    className={`form-control ${errors.payment_amount ? "is-invalid" : ""}`}
                    value={formData.payment_amount}
                    onChange={(e) => handleChange("payment_amount", e.target.value)}
                  />
                </div>
                {errors.payment_amount && (
                  <div className="text-danger small mt-1">{errors.payment_amount}</div>
                )}
              </div>

              {/* Payment Method */}
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Payment Method <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${errors.payment_method ? "is-invalid" : ""}`}
                  value={formData.payment_method}
                  onChange={(e) => handleChange("payment_method", e.target.value)}
                >
                  <option value="cash">Cash</option>
                  <option value="online">Online</option>
                  <option value="upi">UPI</option>
                  <option value="card">Card</option>
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="cheque">Cheque</option>
                </select>
                {errors.payment_method && (
                  <div className="text-danger small mt-1">{errors.payment_method}</div>
                )}
              </div>

              {/* Payment ID */}
              {/* <div className="col-md-6">
                <label className="form-label fw-bold">Payment ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="MANUAL_001"
                  value={formData.payment_id}
                  onChange={(e) => handleChange("payment_id", e.target.value)}
                />
              </div> */}

              {/* Notes */}
              <div className="col-md-6">
                <label className="form-label fw-bold">Notes</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Paid by cash"
                  value={formData.notes}
                  onChange={(e) => handleChange("notes", e.target.value)}
                />
              </div>

              {/* Status */}
              <div className="col-md-6">
                <label className="form-label fw-bold">Status</label>
                <select
                  className="form-select"
                  value={formData.status}
                  onChange={(e) => handleChange("status", e.target.value)}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              {/* Buttons */}
              <div className="col-12 text-end  pt-3 mt-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => navigate(-1)}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button type="submit" className="add-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Saving...
                    </>
                  ) : (
                    "Assign Plan"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AsignToVendorPlan;